import React, { useState } from 'react';
import TabBar from '../../../component/tab-bar/tab-bar';
import { SettingsLecturerRatePriceTypes } from './tabs/rate-price-type/settings-lecturer-rate-price-types';

const tabs = ['תחומי פעילות סגל'];
export const SettingsLecturersPage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 350);
  };

  const elementTabs = [<SettingsLecturerRatePriceTypes />];

  return (
    <div className={'studies-settings-root'}>
      <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>הגדרות מערכת</div>

        <TabBar
          tabs={tabs}
          onClick={(index) => {
            onTabSelected(index);
            console.log('The index ' + index + 'Is clicked');
          }}
        ></TabBar>
        <br />
        {elementTabs[selectedIndex]}
      </div>
    </div>
  );
};
